export const eventTypes = Object.freeze({
  DISCONNECT: 'DISCONNECT',
  NOISE: 'NOISE',
  TAMPER: 'TAMPER',
  BATTERY: 'BATTERY',
  LOST_NETWORK: 'LOST_NETWORK',
  ELEVATED_OCCUPANCY: 'ELEVATED_OCCUPANCY',
})

export const eventLabels = Object.freeze({
  [eventTypes.DISCONNECT]: 'Disconnect',
  [eventTypes.NOISE]: 'Noise',
  [eventTypes.TAMPER]: 'Tamper',
  [eventTypes.BATTERY]: 'Low Battery',
  [eventTypes.LOST_NETWORK]: 'Property Disconnect',
  [eventTypes.ELEVATED_OCCUPANCY]: 'Occupancy (Beta)',
})

export const getEventIcon = (type) => {
  switch (type) {
    case eventTypes.DISCONNECT: return '$faSignalAltSlash'
    case eventTypes.NOISE: return '$faSignalStream'
    case eventTypes.TAMPER: return '$faHandPaper'
    case eventTypes.BATTERY: return '$faBatteryQuarter'
    case eventTypes.LOST_NETWORK: return '$faHouseSignal'
    case eventTypes.ELEVATED_OCCUPANCY: return '$faUsers'
    default: return '$faExclamationCircle'
  }
}

export const getEventLabel = (eventType) => {
  switch (eventType) {
    case eventTypes.DISCONNECT:
      return eventLabels.DISCONNECT
    case eventTypes.NOISE:
      return eventLabels.NOISE
    case eventTypes.TAMPER:
      return eventLabels.TAMPER
    case eventTypes.BATTERY:
      return eventLabels.BATTERY
    case eventTypes.LOST_NETWORK:
      return eventLabels.LOST_NETWORK
    case eventTypes.ELEVATED_OCCUPANCY:
      return eventLabels.ELEVATED_OCCUPANCY
    default:
      return eventType
  }
}
